import React from "react";
import DataTable from "components/DataTable/DataTable";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";
import { IAccessRequestEntity } from "models/AccessRequest.model";
import { useIncomingAccessRequestColumns } from "./functions/useIncomingAccessRequestColumns";
import { useTranslation } from "react-i18next";

type Props = {
  data: IAccessRequestEntity[];
  onClickAccept: (accessRequest: IAccessRequestEntity) => void;
  onClickDecline: (accessRequest: IAccessRequestEntity) => void;
};

const IncomingAccessRequestTable: React.FC<Props> = ({ data, onClickAccept, onClickDecline }) => {
  const { t } = useTranslation();
  const columns = useIncomingAccessRequestColumns({
    onClickAccept,
    onClickDecline,
  });

  return (
    <StyledDataTable
      data-testid={"IncomingAccessRequestTable"}
      data={data}
      columns={columns}
      sortById={"createdDate"}
      sortDesc={true}
      tableLayout={"fixed"}
      verticalAlign={"top"}
      noResultFoundText={t("No access requests")}
    />
  );
};

const StyledDataTable = styled(DataTable)(
  ({ theme }) => css`
    border: 0;

    table > thead > tr > th,
    table > tbody > tr > td {
      border-right: 0;
      vertical-align: middle;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  `
);

export default IncomingAccessRequestTable;
